import { useState } from 'react';
import { uploadVideoWithAudio, getVideoMetadata } from '../services/videoUploadService';
import { useNotification } from '../context/NotificationContext';

export const useVideoUpload = () => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const { showNotification } = useNotification();

  const uploadVideo = async (videoFile: File) => {
    setIsUploading(true);
    setUploadProgress(0);
    
    try {
      // First, get video metadata locally
      const metadata = await getVideoMetadata(videoFile);
      
      // showNotification({
      //   title: 'Uploading Video',
      //   message: `Duration: ${Math.round(metadata.duration)}s, Size: ${(videoFile.size / 1024 / 1024).toFixed(1)}MB`,
      //   type: 'info'
      // });
      
      // Upload video to backend
      const response = await uploadVideoWithAudio(videoFile, (progress) => {
        setUploadProgress(progress);
      });
      
      showNotification({
        title: 'Video Uploaded Successfully',
        message: 'Processing video...',
        type: 'success'
      });
      
      return {
        ...response,
        metadata
      };
      
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to upload video';
      
      showNotification({
        title: 'Upload Failed',
        message: errorMessage,
        type: 'error'
      });
      
      throw error;
      
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  return { 
    uploadVideo, 
    isUploading, 
    uploadProgress 
  };
};
